import BlogCardHorizontal from "@components/BasicComponents/Cards/BlogCard/BlogCardHorizontal"
import {useLocale} from "@components/Contexts/LocaleContext"
import Separator from "@components/CustomTypography/Separator/Separator"
import {Translate} from "@components/Theme/Translate/Translate"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {getPosts} from "@config/modules"
import formatDate from "@helpers/formatDate"
import {translate} from "@helpers/translate"
import {checkIfInBlogCategory} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyAdditionalFunctions"
import {CategoryModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import Blogsjson from "@jsons/blogPosts.json"
import Error from "next/error"
import {useRouter} from "next/router"
import React from "react"

import styles from "./Post.module.scss"
import {PostComponent} from "./PostComponent"

// TODO: Create Normal Template when we will get the design
const Post = (props: PostComponent) => {
	const router = useRouter()
	const {changeLocale: changeLocaleCustome} = useLocale()

	// Trow 404 page for unExist pages
	// ! Required for avoiding errors on server side rendering
	if (!props.data.post) {
		return <Error statusCode={404} />
	}
	const BlogPosts = getPosts("BlogPostsModule", {data: Blogsjson})
	changeLocaleCustome(props.data.post.lang)

	const data = props.data.post

	let blogData = BlogPosts
	const categories = data.category.map(
		(element: CategoryModuleType, index: number) => {
			return element.slug
		},
	)

	if (typeof blogData !== "undefined") {
		blogData = BlogPosts.filter(
			(element: any) => element.slug !== data.slug,
		)
		const FilteredBlogData = checkIfInBlogCategory(blogData, categories)

		if (FilteredBlogData.length > 0) {
			blogData = FilteredBlogData

			if (FilteredBlogData.length === 1) {
				blogData.push(
					BlogPosts.filter(
						(element: any) =>
							element.slug !== data.slug &&
							element.slug !== blogData[0].slug,
					)[0],
				)
			}
		}
	}

	return (
		<>
			<div className={styles.post__container}>
				<div>
					<Separator>
						<Typography
							className={styles.title}
							content={data.title}
							variant={Variant.SectionTitle}
						/>
						<Typography
							content={
								<>
									<Translate capitalizeFirst>
										Posted on
									</Translate>
									: {formatDate(data.upperTitle)}
									{data.category.map(
										(
											element: CategoryModuleType,
											index: number,
										) => {
											return (
												<React.Fragment key={index}>
													{" "}
													|{" "}
													{translate(
														element.title,
														router.locale,
													)}
												</React.Fragment>
											)
										},
									)}
								</>
							}
							fontWeight={300}
							variant={Variant.Paragraph}
							size={Size.XXS}
							noPadding
						/>
					</Separator>
					<div className={styles.contentContainer}>
						<Typography
							content={data.content}
							size={Size.XS}
							fontWeight={300}
							variant={Variant.Description}
							as={"div"}
							noPadding
						/>
					</div>
				</div>
			</div>
			<Separator size={128}>
				<Typography
					content={<Translate capitalizeFirst>Latest News</Translate>}
					variant={Variant.SectionTitle}
				/>
				{blogData.length > 0 && (
					<Separator
						className={styles.cardContainer}
						type={"padding"}
					>
						{blogData.map((element: any, index: number) => {
							if (index < 3) {
								return (
									<BlogCardHorizontal
										key={index}
										className={styles.cardBox}
										data={element}
									/>
								)
							}
							return undefined
						})}
					</Separator>
				)}
			</Separator>
		</>
	)
}

export default Post
